import { baseUrlFrontApi } from '~/js/templates/index/helpers'

$('.order-cancellation .order__cancel-link').on('click', (e) => {
  e.preventDefault()
  const $this = $(e.currentTarget)
  $this.attr('disabled', true)

  const data = {
    o: $this.data('o').toString(),
    // eslint-disable-next-line no-undef
    h: FFJP.hashedOrder,
  }

  $.ajax({
    type: 'POST',
    url: `${baseUrlFrontApi}/order_cancel`,
    contentType: 'application/json',
    crossDomain: true,
    dataType: 'json',
    data: JSON.stringify(data),
    beforeSend: () => {
      $('.modal-container-cancel').css('display', 'none')
      $('#loading-gif').css('display', 'flex')
    },
    complete: (xhr) => {
      if (xhr.status == 200) {
        $('#loading-gif').css('display', 'none')
        $('#modal-cancel p').css('display', 'none')
        $('.modal-container-cancel').css('display', 'block')
        $('.js-order-notice').show()
        $('.js-cancel-link').remove()
        $this.attr('disabled', false)
        $this[0].outerHTML =
          '<span class="order__cancelled">ご注文は正常にキャンセルされました。</span>'
      } else {
        $('#loading-gif').css('display', 'none')
        $('#modal-cancel p').css('display', 'none')
        $('.modal-container-cancel').css('display', 'block')
        $this.attr('disabled', false)

        const msg =
          xhr.responseJSON?.error === 'ORDER_CANNOT_BE_CANCELLED'
            ? '出荷準備中、または発送済みの注文のためキャンセルを承れません。'
            : 'ご注文のキャンセル時にエラーが発生いたしました。<br>再度お試しいただくか、<a href=\'https://help.francfranc.com/hc/ja/requests/new\'>お問い合わせフォーム</a>からお問い合わせください。'
        $this[0].outerHTML = `<span class="order__cancelled">${msg}</span>`
      }
    },
    error: (e) => {
      // eslint-disable-next-line no-console
      console.log(e)
      $this.attr('disabled', false)
    },
  })
})
